import { render, staticRenderFns } from "./CollapseList.vue?vue&type=template&id=5eec2f45&"
import script from "./CollapseList.vue?vue&type=script&lang=ts&"
export * from "./CollapseList.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports